import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-export-row-actions',
    standalone: true,
    imports: [TranslatePipe, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle],
    template: `
        <div ngbDropdown placement="bottom-end top-end" container="body">
            <button
                class="btn btn-link p-0"
                ngbDropdownToggle
                [attr.aria-label]="
                    'savedexport_savedexports_card_actions' | translate: 'online' : 'export'
                ">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <div ngbDropdownMenu>
                <button ngbDropdownItem (click)="edit.emit()">
                    {{ 'common_Edit' | translate }}
                </button>
                @if (showDuplicate()) {
                    <button ngbDropdownItem (click)="duplicate.emit()">
                        {{
                            'savedexport_savedexports_action_duplicate'
                                | translate: 'online' : 'export'
                        }}
                    </button>
                }
                <div class="dropdown-divider"></div>
                <button ngbDropdownItem class="text-danger" (click)="delete.emit()">
                    {{ 'common_Delete' | translate }}
                </button>
            </div>
        </div>
    `,
    styles: `
        .dropdown-toggle::after {
            display: none;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportRowActionsComponent {
    readonly showDuplicate = input(false);

    readonly edit = output<void>();
    readonly duplicate = output<void>();
    readonly delete = output<void>();
}
